import React from 'react';

import classnames from 'classnames';

import { useSize } from '../../../features/config';
import { Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

import type { ButtonProps } from '../../Button';

export type SkeletonButtonProps = Omit<
    Omit<SkeletonProps, 'height' | 'width'> & Pick<ButtonProps, 'size' | 'shape'>,
    'color'
> & {
    width: string | number;
};

export const SkeletonButton = ({
    className,
    size: sizeProp,
    shape = 'default',
    width,
    ...rest
}: SkeletonButtonProps) => {
    const size = useSize(sizeProp, 'large', 'SkeletonButton');

    return (
        <Skeleton
            {...rest}
            className={classnames(styles.button, styles[size], styles[shape], className)}
            height={undefined}
            width={width}
        />
    );
};
